import { Pipe, PipeTransform } from '@angular/core'
import dayjs, { Dayjs } from 'dayjs'

@Pipe({
  name: 'customDate',
})
export class CustomDatePipe implements PipeTransform {
  transform(
    value: string | Date | Dayjs,
    format: string = 'l',
    withoutSuffix: boolean = false
  ): unknown {
    if (!value) return ''

    const d = dayjs.isDayjs(value) ? value : dayjs(value)

    switch (format) {
      case 'fromNow':
        return d.fromNow(withoutSuffix)
      case 'toNow':
        return d.fromNow(withoutSuffix)
      default:
        return d.format(format)
    }
  }
}
